import { render, staticRenderFns } from "./testDialog.vue?vue&type=template&id=6f051ed9&"
import script from "./testDialog.vue?vue&type=script&lang=js&"
export * from "./testDialog.vue?vue&type=script&lang=js&"
import style0 from "./testDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports